import { combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { AddValueAndCareCardState, AddVehicleState, ChangePasswordState, CustomerCardsState, CustomerDataState, CustomerState, /* DeleteAccountState, */ DeleteCardState, DeleteVehicleState, UpdateCustomerForSubscriptionState, UpdateCustomerState, UpdateNifState, UploadProfilePictureState, UploadVehicleDocsState, VehicleAllVisitsState, VehicleDataState, VehicleInvoicesState, VehicleMaintenanceContractPDFState, VehicleMaintenanceContractsState, VehicleMaintenanceContractUpgradesState, VehicleSRPMMState } from './Types';

import * as Actions from './Actions';
export type CustomerAction = ActionType<typeof Actions>;

const customerDataInitialState: CustomerDataState = {
    isCommunicating: false,
    data: {},
    error: false,
};

const vehicleDataInitialState: VehicleDataState = {
    isCommunicating: false,
    data: {},
    error: false,
};

const customerCardsInitialState: CustomerCardsState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const vehicleInvoicesInitialState: VehicleInvoicesState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const vehicleMaintenanceContractsInitialState: VehicleMaintenanceContractsState = {
    isCommunicating: false,
    data: {
        vehcode: -1,
    },
    error: false,
};

const vehicleMaintenanceContractUpgradesInitialState: VehicleMaintenanceContractUpgradesState = {
    isCommunicating: false,
    data: {
        vehcode: -1,
    },
    error: false,
};

const vehicleMaintenanceContractPDFInitialState: VehicleMaintenanceContractPDFState = {
    isCommunicating: false,
    data: undefined,
    error: false,
};

const vehicleSRPMMInitialState: VehicleSRPMMState = {
    isCommunicating: false,
    data: {
        vehcode: -1,
        dealerCode: -1,
        srpmmChart: {
            isPlateAgeValid: false,
        },
    },
    error: false,
};

const vehicleAllVisitsInitialState: VehicleAllVisitsState = {
    isCommunicating: false,
    data: {
        requestedVehcode: -1,
    },
    error: false,
};

const changePasswordInitialState: ChangePasswordState = {
    isCommunicating: false,
    error: false,
};

/*
const deleteAccountInitialState: DeleteAccountState = {
    isCommunicating: false,
    error: false,
};
*/

const updateCustomerInitialState: UpdateCustomerState = {
    isCommunicating: false,
    error: false,
};

const updateCustomerForSubscriptionInitialState: UpdateCustomerForSubscriptionState = {
    isCommunicating: false,
    error: false,
};

const updateNifInitialState: UpdateNifState = {
    isCommunicating: false,
    error: false,
};

const addVehicleInitialState: AddVehicleState = {
    isCommunicating: false,
    error: false,
};

const deleteVehicleInitialState: DeleteVehicleState = {
    isCommunicating: false,
    error: false,
};

const deleteCardInitialState: DeleteCardState = {
    isCommunicating: false,
    error: false,
};

const uploadProfilePictureInitialState: UploadProfilePictureState = {
    isCommunicating: false,
    error: false,
};

const uploadVehicleDocsInitialState: UploadVehicleDocsState = {
    isCommunicating: false,
    error: false,
};

const addValueAndCareCardInitialState: AddValueAndCareCardState = {
    isCommunicating: false,
    error: false,
};

export default combineReducers<CustomerState, CustomerAction>({

    customerData: (state = customerDataInitialState, action) => {
        switch (action.type) {
            case getType(Actions.customerDataRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {},
                };
            case getType(Actions.customerDataSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        customerData: action.payload,
                    },
                    error: false,
                };
            case getType(Actions.customerDataFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {},
                    error: true,
                };
            default:
                return state;
        }
    },
    vehicleData: (state = vehicleDataInitialState, action) => {
        switch (action.type) {
            case getType(Actions.vehicleDataRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {},
                };
            case getType(Actions.vehicleDataSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        vehicleData: action.payload,
                    },
                    error: false,
                };
            case getType(Actions.vehicleDataFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {},
                    error: true,
                };
            default:
                return state;
        }
    },
    customerCards: (state = customerCardsInitialState, action) => {
        switch (action.type) {
            case getType(Actions.customerCardsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.customerCardsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.customerCardsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    vehicleInvoices: (state = vehicleInvoicesInitialState, action) => {
        switch (action.type) {
            case getType(Actions.vehicleInvoicesRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.vehicleInvoicesSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.vehicleInvoicesFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    vehicleMaintenanceContracts: (state = vehicleMaintenanceContractsInitialState, action) => {
        switch (action.type) {
            case getType(Actions.vehicleMaintenanceContractsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {
                        vehcode: -1,
                    },
                };
            case getType(Actions.vehicleMaintenanceContractsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.vehicleMaintenanceContractsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        vehcode: -1,
                    },
                    error: true,
                };
            default:
                return state;
        }
    },
    vehicleMaintenanceContractUpgrades: (state = vehicleMaintenanceContractUpgradesInitialState, action) => {
        switch (action.type) {
            case getType(Actions.vehicleMaintenanceContractUpgradesRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {
                        vehcode: -1,
                    },
                };
            case getType(Actions.vehicleMaintenanceContractUpgradesSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.vehicleMaintenanceContractUpgradesFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        vehcode: -1,
                    },
                    error: true,
                };
            default:
                return state;
        }
    },
    vehicleMaintenanceContractPDF: (state = vehicleMaintenanceContractPDFInitialState, action) => {
        switch (action.type) {
            case getType(Actions.vehicleMaintenanceContractPDFRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.vehicleMaintenanceContractPDFSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.vehicleMaintenanceContractPDFFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    vehicleSRPMM: (state = vehicleSRPMMInitialState, action) => {
        switch (action.type) {
            case getType(Actions.vehicleSRPMMRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {
                        vehcode: -1,
                        dealerCode: -1,
                        srpmmChart: {
                            isPlateAgeValid: false,
                        },
                    },
                };
            case getType(Actions.vehicleSRPMMSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.vehicleSRPMMFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        vehcode: -1,
                        dealerCode: -1,
                        srpmmChart: {
                            isPlateAgeValid: false,
                        },
                    },
                    error: true,
                };
            default:
                return state;
        }
    },
    vehicleAllVisits: (state = vehicleAllVisitsInitialState, action) => {
        switch (action.type) {
            case getType(Actions.vehicleAllVisitsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: {
                        requestedVehcode: -1,
                    },
                };
            case getType(Actions.vehicleAllVisitsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.vehicleAllVisitsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: {
                        requestedVehcode: -1,
                    },
                    error: true,
                };
            default:
                return state;
        }
    },
    changePassword: (state = changePasswordInitialState, action) => {
        switch (action.type) {
            case getType(Actions.changePasswordRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.changePasswordSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.changePasswordFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    /*
    deleteAccount: (state = deleteAccountInitialState, action) => {
        switch (action.type) {
            case getType(Actions.deleteAccountRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.deleteAccountSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.deleteAccountFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    */
    updateCustomer: (state = updateCustomerInitialState, action) => {
        switch (action.type) {
            case getType(Actions.updateCustomerRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.updateCustomerSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.updateCustomerFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    updateCustomerForSubscription: (state = updateCustomerForSubscriptionInitialState, action) => {
        switch (action.type) {
            case getType(Actions.updateCustomerForSubscriptionRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.updateCustomerForSubscriptionSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.updateCustomerForSubscriptionFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    updateNif: (state = updateNifInitialState, action) => {
        switch (action.type) {
            case getType(Actions.updateNifRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.updateNifSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.updateNifFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    addVehicle: (state = addVehicleInitialState, action) => {
        switch (action.type) {
            case getType(Actions.addVehicleRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.addVehicleSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.addVehicleFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    deleteVehicle: (state = deleteVehicleInitialState, action) => {
        switch (action.type) {
            case getType(Actions.deleteVehicleRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.deleteVehicleSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.deleteVehicleFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    deleteCard: (state = deleteCardInitialState, action) => {
        switch (action.type) {
            case getType(Actions.deleteCardRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.deleteCardSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.deleteCardFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    uploadProfilePicture: (state = uploadProfilePictureInitialState, action) => {
        switch (action.type) {
            case getType(Actions.uploadProfilePictureRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.uploadProfilePictureSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.uploadProfilePictureFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    uploadVehicleDocs: (state = uploadVehicleDocsInitialState, action) => {
        switch (action.type) {
            case getType(Actions.uploadVehicleDocsRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.uploadVehicleDocsSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.uploadVehicleDocsFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },
    addValueAndCareCard: (state = addValueAndCareCardInitialState, action) => {
        switch (action.type) {
            case getType(Actions.addValueAndCareCardRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.addValueAndCareCardSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.addValueAndCareCardFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },

});
